enum UtmSource {
  FITTER_COCKPIT = 'fitter-cockpit',
  FLOW_CLIENT = 'flow-client',
  SALESFORCE = 'salesforce',
}

export { UtmSource }
